import type React from 'react';
import { lazy, Suspense } from 'react';
import { PageLoading } from '@/app/components/page-loading.tsx';
import { useAuth } from '@/app/hooks/auth-provider';
import { UserTypeEnum } from '../../types/user-type.ts';

const LazyRepMeetingEdit = lazy(() => import('./RepMeetingEdit'));

const RepMeetingEdit = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => {
  const { user } = useAuth();
  return (
    <Suspense fallback={<PageLoading />}>
      {user?.userType === UserTypeEnum.DrugRep && <LazyRepMeetingEdit {...props} />}
    </Suspense>
  );
};

export const repMeetingEditRoute = {
  path: '/meeting-edit/:key',
  element: <RepMeetingEdit />,
};

export default RepMeetingEdit;
